import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsBusinessService } from 'src/app/core/business/settings/settings-business.service';
import { DailyScheduleDTO } from 'src/app/domain/settings/daily-schedule.dto';
import { ScheduleCreate } from 'src/app/core/models/settings/daily-schedule-create';
import { DailySchedule } from 'src/app/core/models/settings/daily-schedule.model';
import { DailyScheduleTime } from 'src/app/core/models/settings/daily-schedule-time.model';
@Injectable({
  providedIn: 'root'
})
export class SettingsFacadesService {

  constructor(private settingsBusiness: SettingsBusinessService) { }

  createOpenHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    return this.settingsBusiness.createOpenHours(data);
  }

  updateOpenHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    return this.settingsBusiness.updateOpenHours(data);
  }

  getOpenHoursById(data: DailySchedule): Observable<DailyScheduleDTO[]> {
    return this.settingsBusiness.getOpenHoursById(data);
  }
  cancelOpenHours(data: DailyScheduleTime): Observable<DailyScheduleTime> {
    return this.settingsBusiness.cancelOpenHours(data);
  }
  downloadQrPoster(data: object){
    return this.settingsBusiness.downloadQrPoster(data);
  }
}
